import { VStack, Text } from "@chakra-ui/layout";
import { Tab, Tabs, TabList, TabPanels, TabPanel, TabIndicator } from "@chakra-ui/tabs";
import React, { useEffect, useState } from "react";
import { getAssessment } from "api/webservice/content";
import { useAssessmentContext } from "hooks/assessment";

import { Session } from "types";
import Conversation from "components/Assessment/3TierCheckList/Conversation";

interface Subtopic {
  fields: any;
}

interface Props {
  session: Session;
/*   responses: any[]; */
  componentHeight: number;
  toggleGameLiftStreamsInput: any;
}

const IASSER2T: React.FC<Props> = ({ session, /* , responses */ componentHeight, toggleGameLiftStreamsInput }: Props) => {

  const [categories, setCategories] = useState<Array<Subtopic>>([]);
/*   const [categoryTags, setCategoryTags] = useState<Array<string>>([]); */

  const { loading } = useAssessmentContext();

  useEffect(() => {
    getAssessment()
      .then(result => {
        if (!result.items) return false;
        const categories = result.items;
        const categoryGroups = categories[0].fields.allCategories;
        const tags = categoryGroups.map((category: any) => category.fields.tag)
        setCategories(categoryGroups);
/*         setCategoryTags(tags); */
      });
  }, []);

  return (
    loading ?
      <Text> Loading ... </Text> :
    <VStack>
      <Tabs isFitted variant="unstyled">
        <TabList
          color="white"
          borderColor={"transparent"}
          borderBottomWidth={"2px"}
          borderBottomColor={"gray.100"}
          fontWeight={"light"}
        >
          <Tab>
            1
          </Tab>
          <Tab>
            2
          </Tab>
          <Tab>
            3
          </Tab>
          <Tab>
            4
          </Tab>
        </TabList>
        <TabIndicator
          color="white"
          borderBottomColor={"blue.500"}
          borderBottomWidth={"4px"}
          mt="-4.0px"
        />
        <TabPanels>
          <TabPanel>
            <Conversation conversationNumber={0} categories={categories} componentHeight={componentHeight} toggleGameLiftStreamsInput={toggleGameLiftStreamsInput}/>
          </TabPanel>
          <TabPanel>
            <Conversation conversationNumber={1} categories={categories} componentHeight={componentHeight} toggleGameLiftStreamsInput={toggleGameLiftStreamsInput}/>
          </TabPanel>
          <TabPanel>
            <Conversation conversationNumber={2} categories={categories} componentHeight={componentHeight} toggleGameLiftStreamsInput={toggleGameLiftStreamsInput}/>
          </TabPanel>
          <TabPanel>
            <Conversation conversationNumber={3} categories={categories} componentHeight={componentHeight} toggleGameLiftStreamsInput={toggleGameLiftStreamsInput}/>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </VStack>
  );
};

export default IASSER2T;
